<template>
  <div class="relative">
    <slot></slot>
    <transition name="fade">
      <div
        v-if="isVisible"
        class="bg-background-neutral-secondary absolute left-auto top-auto mt-2 w-72 rounded-2xl p-3 text-xs"
      >
        <div
          class="-z-1 bg-background-neutral-secondary absolute -top-[5px] left-1/4 h-3 w-3 -translate-x-1/2 rotate-45"
        ></div>
        <div class="z-10 flex items-center space-x-3">
          <p class="text-text-neutral-secondary">
            {{ t('search.filters.personalOffer') }}
          </p>
          <button
            class="min-h-3 min-w-3"
            type="button"
            @click="emit('onClose')"
          >
            <CloseIcon class="text-text-neutral-secondary h-3 w-3" />
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import CloseIcon from '@/assets/images/close-icon.svg?component';

  defineProps<{
    isVisible: boolean;
  }>();

  const emit = defineEmits<{
    onClose: [];
  }>();

  const { t } = useI18n();
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition:
      opacity 0.3s ease,
      transform 0.3s ease;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(-5px);
  }
</style>
